const jsonUtils = {};

jsonUtils.removeFromPath = (path, data) => {
    if (path.length > 1) {
        jsonUtils.removeFromPath(path.slice(1) , data[path[0]]);
    } else {
        if (Array.isArray(data)) {
            data.splice(path, 1);
        }
        delete data[path];
    }
};

export default jsonUtils;